import { fetchData, insertData, updatetDataById } from "api";
import {
  examinations,
  history,
  impressions,
  locations,
  otherSymptoms,
  reports,
  symptoms,
  systems,
  treatment_plans,
} from "api/collection_names";
import React, { useEffect, useState } from "react";
import { categoryModal } from "models/complaints/complaint-modals";
import Card from "components/card";
import {
  EITModal,
  ExaminationModal,
  LocationWithScrollDowns,
  UpdatedReportModal,
  WizardOptionModal,
  WizardProps,
  defaultBtnObj,
  durationListArray,
  wizardDisplayModal,
  LocationModal,
  formatLocationsText,
} from "models/wizard/wizard-modals";
import "assets/css/App.css";
import WizardManagement from "./wizardManagement";
import WizardReport from "./wizardReport";
import completeAnimation from "../../../assets/animations/Animation - 1710686330018.json";
import Lottie from "react-lottie";
import { MdAddCircle } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import { getBasePriority } from "utils/priority-utils";
import { SnackbarState } from "models/user-models";
import AppSnackbar from "components/snakbar";
import { getUser } from "auth/Authentication";
import { VoiceNoteReport } from "api/ai";

const Wizard: React.FC<WizardProps> = ({ selectedUser }) => {
  const navigate = useNavigate();

  const [screenHeight, setScreenHeight] = useState(0);
  const [page, setPage] = useState<number>(1);
  const [systemList, setSystemList] = useState<categoryModal[]>([]);
  const [complaintList, setComplaintList] = useState<categoryModal[]>([]);
  const [otherSymptomList, setOtherSymptomList] = useState<categoryModal[]>([]);
  const [historyList, setHistoryList] = useState<categoryModal[]>([]);
  const [examinationList, setExaminationList] = useState<ExaminationModal[]>(
    []
  );
  const [impressionList, setImpressionList] = useState<EITModal[]>([]);
  const [treatmentList, setTreatmentList] = useState<EITModal[]>([]);
  const [durationList] = useState<wizardDisplayModal[]>(durationListArray);
  const [locationList, setLocationList] = useState<LocationModal[]>();
  const [loading, setLoading] = useState<boolean>(false);
  const [duration, setDuration] = useState<number | null>(null);
  const [durationType, setDurationType] = useState("");
  const [complaintLocation, setComplaintLocation] = useState<
    LocationWithScrollDowns[]
  >([]);
  const [otherSymptomDuration, setOtherSymptomDuration] = useState<
    number | null
  >(null);
  const [otherSymptomDurationType, setOtherSymptomDurationType] = useState("");
  const [otherSymptomLocation, setOtherSymptomLocation] = useState<
    LocationWithScrollDowns[]
  >([]);
  const [historyDuration, setHistoryDuration] = useState<number | null>(null);
  const [historyDurationType, setHistoryDurationType] = useState("");
  const [examinationLocation, setExaminationLocation] = useState<
    LocationWithScrollDowns[]
  >([]);
  const [impressionLocation, setImpressionLocation] = useState<
    LocationWithScrollDowns[]
  >([]);
  const [isCompleted, setIsCompleted] = useState<boolean>(false);
  const [complaintRemark, setComplaintRemark] = useState("");
  const [otherSymptomRemark, setOtherSymptomRemark] = useState("");
  const [historyRemark, setHistoryRemark] = useState("");
  const [impressionRemark, setImpressionRemark] = useState("");
  const [examinationRemark, setExaminationRemark] = useState("");
  const [treatmentRemark, setTreatmentRemark] = useState("");
  const [data, setData] = React.useState<
    { description: string; value: defaultBtnObj[] }[]
  >([]);
  const [subscription, setSubscription] = useState(false);
  const [localUser, setLocalUser] = useState(null);
  const [isExpired, setIsExpired] = useState(null);
  const [isErase, setIsErase] = useState(false);
  const [resetTrigger, setResetTrigger] = useState(false);

  const [filteredLocations, setFilteredLocations] = useState<LocationModal[]>(
    []
  );

  const resetSelectedOptions = () => {
    setResetTrigger(true);
  };

  const location = useLocation();

  const [isChecked, setIsChecked] = useState(false);
  const [report, setReport] = useState<UpdatedReportModal>({
    system: null,
    complaints: [],
    otherSymptoms: [],
    history: [],
    examinations: [],
    impressions: [],
    treatment_plans: [],
  });

  const [snackbar, setSnackbar] = useState<SnackbarState>({
    open: false,
    message: "",
    severity: "info",
  });

  const getData = async () => {
    try {
      setLoading(true);
      const systemsDB = await fetchData(systems);
      const complaintsDB = await fetchData(symptoms);
      const otherSymptomsDB = await fetchData(otherSymptoms);
      const historyDB = await fetchData(history);
      const examinationDB = await fetchData(examinations);
      const impressionDB = await fetchData(impressions);
      const treatmentDB = await fetchData(treatment_plans);
      const locationsDB = await fetchData(locations);

      if (systemsDB.success) {
        const systemsArray: categoryModal[] = [];
        systemsDB.data.map((x: categoryModal) => systemsArray.push(x));
        setSystemList(systemsArray);

        setSystemList((prev) =>
          [...prev].sort((a, b) => getBasePriority(a.priority) - getBasePriority(b.priority))
        );
      } else {
        alert("System list not found!");
        navigate("/auth/sign-in");
      }

      if (complaintsDB.success) {
        const complaintArray: categoryModal[] = [];
        complaintsDB.data.map((x: categoryModal) => complaintArray.push(x));
        setComplaintList(complaintArray);
        setComplaintList((prev) =>
          [...prev].sort((a, b) => getBasePriority(a.priority) - getBasePriority(b.priority))
        );
      } else {
        // alert("Complaint list not found!")
      }

      if (otherSymptomsDB.success) {
        const otherSymptomsArray: categoryModal[] = [];
        otherSymptomsDB.data.map((x: categoryModal) =>
          otherSymptomsArray.push(x)
        );
        setOtherSymptomList(otherSymptomsArray);
        setOtherSymptomList((prev) =>
          [...prev].sort((a, b) => getBasePriority(a.priority) - getBasePriority(b.priority))
        );
      } else {
        // alert("Other Symptom list not found!")
      }

      if (historyDB.success) {
        const historyArray: categoryModal[] = [];
        historyDB.data.map((x: categoryModal) => historyArray.push(x));
        setHistoryList(historyArray);
        setHistoryList((prev) =>
          [...prev].sort((a, b) => getBasePriority(a.priority) - getBasePriority(b.priority))
        );
      } else {
        // alert("Other Symptom list not found!")
      }

      if (examinationDB.success) {
        const examinationArray: ExaminationModal[] = [];
        examinationDB.data.map((x: ExaminationModal) =>
          examinationArray.push(x)
        );
        setExaminationList(examinationArray);
        setExaminationList((prev) =>
          [...prev].sort((a, b) => getBasePriority(a.priority) - getBasePriority(b.priority))
        );
      } else {
        // alert("Examination list not found!")
      }

      if (impressionDB.success) {
        const impressionArray: EITModal[] = [];
        impressionDB.data.map((x: EITModal) => impressionArray.push(x));
        setImpressionList(impressionArray);
        setImpressionList((prev) =>
          [...prev].sort((a, b) => getBasePriority(a.priority) - getBasePriority(b.priority))
        );
      } else {
        // alert("Assessment list not found!")
      }

      if (treatmentDB.success) {
        const treatmentArray: EITModal[] = [];
        treatmentDB.data.map((x: EITModal) => treatmentArray.push(x));
        setTreatmentList(treatmentArray);
        setTreatmentList((prev) =>
          [...prev].sort((a, b) => getBasePriority(a.priority) - getBasePriority(b.priority))
        );
      } else {
        // alert("Treatment list not found!")
      }

      if (locationsDB.success) {
        const locationsArray: LocationModal[] = [];
        locationsDB.data.map((x: LocationModal) => locationsArray.push(x));
        setLocationList(locationsArray);

        const sorted = [...locationsDB.data].sort(
          (a, b) => a.priority - b.priority
        );
        setLocationList(sorted);
      } else {
        alert("location list not found!");
        navigate("/auth/sign-in");
      }

      setLoading(false);
    } catch (error: any) {
      const alreadyLoggedIn = error.message.endsWith("401");
      if (alreadyLoggedIn) {
        setSnackbar({
          open: true,
          message: "logged in from some other device",
          severity: "error",
        });
        setTimeout(() => {
          navigate("/auth/sign-in");
        }, 3000);
      }
    }
  };

  useEffect(() => {
    if (report.system && locationList) {
      let filtered = locationList.filter((location) =>
        !location.system_id ||
        location.system_id.length === 0 ||
        location.system_id.includes(report.system._id)
      );
      setFilteredLocations(filtered);
    } else if (locationList) {
      setFilteredLocations(locationList);
    }
  }, [report.system, locationList]);

  const staticExaminations = [...data];
  const userExamination: any[] = [];
  const updateReportList = (
    data: WizardOptionModal[],
    selectedSubOtherSymptom: wizardDisplayModal[],
    selectedSubHistory: wizardDisplayModal[],
    selectedSubExams: wizardDisplayModal[],
    selectedSubImp: wizardDisplayModal[],
    selectedSubComp: wizardDisplayModal[],
    selectedSubTreatPlan: wizardDisplayModal[]
  ) => {
    let updatedReport: UpdatedReportModal = {
      system: null,
      complaints: [],
      otherSymptoms: [],
      history: [],
      examinations: [],
      impressions: [],
      treatment_plans: [],
    };
    if (data && data.length) {
      for (let i = 0; i < data.length; i++) {
        const x = data[i];
        if (x.page_name === "Systems") {
          updatedReport.system = systemList.filter(
            (item) => item._id === x.id
          )[0];
        } else if (x.page_name === "Complaints") {
          // updatedReport.complaints.push(complaintList.filter(item => item._id === x.id)[0])
          let filteredComplaint = {
            ...complaintList.filter((item) => item._id === x.id)[0],
          };
          filteredComplaint.scroll_downs = [];
          let compScrollDowns = selectedSubComp.filter(
            (subComp) => subComp.id === x.id
          );
          compScrollDowns.forEach((subComp) => {
            filteredComplaint.scroll_downs.push(subComp.description);
          });
          updatedReport.complaints.push(filteredComplaint);
        } else if (x.page_name === "OtherSymptoms") {
          // updatedReport.complaints.push(complaintList.filter(item => item._id === x.id)[0])
          let filteredOtherSymptom = {
            ...otherSymptomList.filter((item) => item._id === x.id)[0],
          };
          filteredOtherSymptom.scroll_downs = [];
          let compScrollDowns = selectedSubOtherSymptom.filter(
            (subOS) => subOS.id === x.id
          );
          compScrollDowns.forEach((subOS) => {
            filteredOtherSymptom.scroll_downs.push(subOS.description);
          });
          updatedReport.otherSymptoms.push(filteredOtherSymptom);
        } else if (x.page_name === "History") {
          // updatedReport.complaints.push(complaintList.filter(item => item._id === x.id)[0])
          let filteredHistory = {
            ...historyList.filter((item) => item._id === x.id)[0],
          };
          filteredHistory.scroll_downs = [];
          let compScrollDowns = selectedSubHistory.filter(
            (subHistory) => subHistory.id === x.id
          );
          compScrollDowns.forEach((subHistory) => {
            filteredHistory.scroll_downs.push(subHistory.description);
          });
          updatedReport.history.push(filteredHistory);
        }
        // else if (x.page_name === "Sub Complaints") {
        //     let subComplaint = { ...complaintList.filter(item => item._id === x.id)[0] };
        //     // Only add subconditions that were explicitly selected for this complaint
        //     subComplaint.scroll_downs = selectedSubComp
        //         .filter(subComp => subComp.id === x.id)
        //         .map(subComp => subComp.description);
        //     updatedReport.subComplaints.push(subComplaint);
        // }
        else if (x.page_name === "Examinations") {
          let exam = {
            ...examinationList.filter((item) => item._id === x.id)[0],
          };
          let arr = selectedSubExams.filter((sub_exam) => sub_exam.id === x.id);
          exam.scroll_downs = [];
          arr.forEach((x) =>
            exam.scroll_downs.push({
              description: x.description,
              priority: getBasePriority(x.priority),
            })
          );
          userExamination.push(exam);
        } else if (x.page_name === "Assessments") {
          // updatedReport.impressions.push(impressionList.filter(item => item._id === x.id)[0])
          let filteredImpression = {
            ...impressionList.filter((item) => item._id === x.id)[0],
          };
          filteredImpression.scroll_downs = [];
          let impScrollDowns = selectedSubImp.filter(
            (subImp) => subImp.id === x.id
          );
          impScrollDowns.forEach((subImp) => {
            filteredImpression.scroll_downs.push(subImp.description);
          });
          updatedReport.impressions.push(filteredImpression);
        } else if (x.page_name === "Plans") {
          // updatedReport.treatment_plans.push(treatmentList.filter(item => item._id === x.id)[0])
          let filteredTreatPlan = {
            ...treatmentList.filter((item) => item._id === x.id)[0],
          };
          filteredTreatPlan.scroll_downs = [];
          let treatPlanScrollDowns = selectedSubTreatPlan.filter(
            (subTreat) => subTreat.id === x.id
          );
          treatPlanScrollDowns.forEach((subTreat) => {
            filteredTreatPlan.scroll_downs.push(subTreat.description);
          });
          updatedReport.treatment_plans.push(filteredTreatPlan);
        }
      }
    }

    const allExaminations = [...userExamination, ...staticExaminations];
    updatedReport.examinations.push(...allExaminations);
    if (isErase) {
      setIsErase(false);
      return;
    }
    setReport(updatedReport);
  };

  const handleVoiceReportGenerated = (voiceReport: VoiceNoteReport) => {
    setReport({
      system: voiceReport.system || null,
      complaints: voiceReport.complaints || [],
      otherSymptoms: voiceReport.otherSymptoms || [],
      history: voiceReport.history || [],
      examinations: voiceReport.examinations || [],
      impressions: voiceReport.impressions || [],
      treatment_plans: voiceReport.treatment_plans || [],
    });
    setDuration(voiceReport.duration ?? null);
    setDurationType(voiceReport.durationType || "");
    setComplaintRemark(voiceReport.complaintRemark || "");
    setOtherSymptomRemark(voiceReport.otherSymptomRemark || "");
    setHistoryRemark(voiceReport.historyRemark || "");
    setImpressionRemark(voiceReport.impressionRemark || "");
    setExaminationRemark(voiceReport.examinationRemark || "");
    setTreatmentRemark(voiceReport.treatmentRemark || "");
  };

  const printReport = async () => {
    const user = getUser();
    const hasTrialExpired = (expirationTimeUTC: any) => {
      const currentTimeUTC = new Date().toISOString();
      return currentTimeUTC > expirationTimeUTC;
    };

    if (
      user.type === "2" &&
      !isChecked &&
      hasTrialExpired(user.trial_expiry) &&
      !user.hasOwnProperty("expiryTime")
    ) {
      setSnackbar({
        open: true,
        message:
          "Your trial has expired. Please switch to the subscription mode.",
        severity: "error",
      });
      return;
    }

    if (user.type === "2" && (isExpired || localUser.package_name === null)) {
      setSnackbar({
        open: true,
        message: "Your trial has ended. Please renew your subscription.",
        severity: "error",
      });
      await updatetDataById(
        "Users",
        {
          package_name: null,
          phone_number: null,
          session_id: null,
          expiryTime: null,
        },
        localUser._id
      );

      const updatedUser = localUser;
      updatedUser.package_name = null;
      updatedUser.phone_number = null;
      updatedUser.session_id = null;
      updatedUser.expiryTime = null;
      updatedUser.subscription = "inactive";
      updatedUser.subscriptionOwner = false;
      updatedUser.subscriptionOwnerId = null;
      updatedUser.randomCode = null;

      localStorage.setItem("user", JSON.stringify(updatedUser));
      return;
    }

    if (report.examinations && report.examinations.length > 0) {
      report.examinations.sort((a, b) => {
        const aHasId = "_id" in a && a._id;
        const bHasId = "_id" in b && b._id;
        return aHasId ? 1 : bHasId ? -1 : 0;
      });
    }

    const getScrollDownsText = (scrollDowns: any) => {
      if (!scrollDowns || scrollDowns.length === 0) return "";
      return scrollDowns.map((sd: any) => sd.description || sd).join(", ");
    };

    const printWindow = window.open("", "_blank");
    printWindow?.document.write(`
    <html>
    <head>
      <title>Medical Note</title>
      <style>
        body {
          font-family: 'DM Sans', Arial, sans-serif;
          margin: 40px;
          color: #333;
          line-height: 1.5;
        }
        .header {
          text-align: center;
          margin-bottom: 30px;
          border-bottom: 2px solid #333;
          padding-bottom: 10px;
        }
        .header h1 {
          margin: 0;
          font-size: 24px;
          font-weight: 600;
        }
        .section {
          margin-bottom: 20px;
        }
        .section-title {
          font-size: 18px;
          font-weight: 600;
          color: #1a1a1a;
          margin-bottom: 8px;
          margin-top: 15px;
          border-bottom: 1px solid #ddd;
          padding-bottom: 5px;
        }
        .section-content {
          margin-left: 0px;
          font-size: 14px;
          line-height: 1.6;
        }
        .content-item {
          margin-bottom: 6px;
          display: block;
        }
        .content-item span {
          display: inline;
        }
        .location-label {
          font-weight: 500;
        }
        .duration-text {
          display: inline;
        }
        .remark {
          display: block;
        }
        .examination-item {
          margin-bottom: 6px;
        }
        .examination-value {
          color: #666;
        }
        .bullet-item {
          margin-left: 20px;
          margin-bottom: 4px;
        }
        @media print {
          body {
            margin: 20px;
          }
        }
      </style>
    </head>
    <body>
      <div class="header">
        <h1>Medical Note</h1>
      </div>

      ${
        (report.complaints && report.complaints.length > 0) || complaintRemark
          ? `
      <div class="section">
        <div class="section-title">Subjective</div>
        <div class="section-content">
          ${
            report.complaints && report.complaints.length > 0
              ? report.complaints
                  .map((complaint) => {
                    let html = `<div class="content-item"><span class="font-medium">${complaint.description}</span>`;

                    if (
                      complaint.scroll_downs &&
                      complaint.scroll_downs.length > 0
                    ) {
                      html += ` <span>${complaint.scroll_downs.join(
                        ", "
                      )}</span>`;
                    }

                    if (
                      duration !== null ||
                      (durationType &&
                        durationType !== "Seconds" &&
                        durationType !== "")
                    ) {
                      const durationText = duration
                        ? duration != 1
                          ? durationType.slice(-1) === "s"
                            ? durationType
                            : durationType + "s"
                          : durationType.slice(-1) === "s"
                          ? durationType.slice(0, -1)
                          : durationType
                        : durationType.toLowerCase();
                      html += `<br/><span class="duration-text">since ${
                        duration ? duration + " " : ""
                      }${durationText}</span>`;
                    }

                    if (
                      Array.isArray(complaintLocation) &&
                      complaintLocation.length > 0 &&
                      Boolean(formatLocationsText(complaintLocation))
                    ) {
                      const locText = formatLocationsText(complaintLocation);
                      html += `<br/><span class="location-label">Location: ${locText}</span>`;
                    }

                    html += `</div>`;
                    return html;
                  })
                  .join("")
              : ""
          }
          ${
            complaintRemark
              ? `<div class="remark">${complaintRemark}</div>`
              : ""
          }
        </div>
      </div>
    `
          : ""
      }

      ${
        (report.otherSymptoms && report.otherSymptoms.length > 0) ||
        otherSymptomRemark
          ? `
      <div class="section">
        <div class="section-content">
          ${
            report.otherSymptoms && report.otherSymptoms.length > 0
              ? report.otherSymptoms
                  .map((os) => {
                    let html = `<div class="content-item"><span>${os.description}</span>`;

                    if (os.scroll_downs && os.scroll_downs.length > 0) {
                      html += ` <span>${os.scroll_downs.join(", ")}</span>`;
                    }

                    html += `</div>`;
                    return html;
                  })
                  .join("")
              : ""
          }
          ${
            report.otherSymptoms &&
            report.otherSymptoms.length > 0 &&
            (otherSymptomDuration !== null ||
              (otherSymptomDurationType &&
                otherSymptomDurationType !== "Seconds" &&
                otherSymptomDurationType !== ""))
              ? `<div class="content-item"><span class="duration-text">since ${
                  otherSymptomDuration ? otherSymptomDuration + " " : ""
                }${
                  otherSymptomDuration
                    ? otherSymptomDuration != 1
                      ? otherSymptomDurationType.slice(-1) === "s"
                        ? otherSymptomDurationType
                        : otherSymptomDurationType + "s"
                      : otherSymptomDurationType.slice(-1) === "s"
                      ? otherSymptomDurationType.slice(0, -1)
                      : otherSymptomDurationType
                    : otherSymptomDurationType.toLowerCase()
                }</span></div>`
              : ""
          }
          ${
            report.otherSymptoms &&
            report.otherSymptoms.length > 0 &&
            Array.isArray(otherSymptomLocation) &&
            otherSymptomLocation.length > 0 &&
            Boolean(formatLocationsText(otherSymptomLocation))
              ? `<div class="content-item"><span class="location-label">Location: ${formatLocationsText(
                  otherSymptomLocation
                )}</span></div>`
              : ""
          }
          ${
            otherSymptomRemark
              ? `<div class="remark">${otherSymptomRemark}</div>`
              : ""
          }
        </div>
      </div>
    `
          : ""
      }

      ${
        (report.history && report.history.length > 0) || historyRemark
          ? `
      <div class="section">
        <div class="section-title">HISTORY</div>
        <div class="section-content">
          ${
            report.history && report.history.length > 0
              ? report.history
                  .map((item) => {
                    let html = `<div class="content-item"><span>${item.description}</span>`;

                    if (item.scroll_downs && item.scroll_downs.length > 0) {
                      html += ` <span>${item.scroll_downs.join(", ")}</span>`;
                    }

                    html += `</div>`;
                    return html;
                  })
                  .join("")
              : ""
          }
          ${
            report.history &&
            report.history.length > 0 &&
            (historyDuration !== null ||
              (historyDurationType &&
                historyDurationType !== "Seconds" &&
                historyDurationType !== ""))
              ? `<div class="content-item"><span class="duration-text">since ${
                  historyDuration ? historyDuration + " " : ""
                }${
                  historyDuration
                    ? historyDuration != 1
                      ? historyDurationType.slice(-1) === "s"
                        ? historyDurationType
                        : historyDurationType + "s"
                      : historyDurationType.slice(-1) === "s"
                      ? historyDurationType.slice(0, -1)
                      : historyDurationType
                    : historyDurationType.toLowerCase()
                }</span></div>`
              : ""
          }
          ${historyRemark ? `<div class="remark">${historyRemark}</div>` : ""}
        </div>
      </div>
    `
          : ""
      }

      ${
        (report.examinations && report.examinations.length > 0) ||
        examinationRemark
          ? `
      <div class="section">
        <div class="section-title">ON EXAMINATION</div>
        <div class="section-content">
          ${
            report.examinations && report.examinations.length > 0
              ? report.examinations
                  .map((item: any) => {
                    let examinationText = "";

                    if (item.description !== "Height & Weight") {
                      examinationText = `${item.description}`;
                    }

                    let weightKG = item.value?.find(
                      (x: any) => x.unitValue === "Kilos"
                    );
                    let weightPounds = item.value?.find(
                      (x: any) => x.unitValue === "Pounds"
                    );
                    let heightCM = item.value?.find(
                      (x: any) => x.unitValue === "Centimeters"
                    );
                    let heightFeets = item.value?.find(
                      (x: any) => x.unitValue === "Feets"
                    );
                    let heightInches = item.value?.find(
                      (x: any) => x.unitValue === "Inches"
                    );

                    if (weightKG) {
                      examinationText = `Height: ${heightCM?.inputValue} centimeters, Weight: ${weightKG?.inputValue} kilos`;
                    }

                    if (weightPounds) {
                      examinationText = `Height: ${heightFeets?.inputValue} feets ${heightInches?.inputValue} inches, Weight: ${weightPounds?.inputValue} pounds`;
                    }

                    if (
                      !weightKG &&
                      !weightPounds &&
                      item?.value &&
                      item.value.length > 0 &&
                      item.value[0]
                    ) {
                      examinationText += `: ${
                        item.value[0].inputValue ? item.value[0].inputValue : ""
                      } ${
                        item.value[0].unitValue ? item.value[0].unitValue : ""
                      }`.trim();
                    }

                    if (item.scroll_downs && item.scroll_downs.length > 0) {
                      examinationText += ` ${getScrollDownsText(
                        item.scroll_downs
                      )}`;
                    }

                    return `<div class="examination-item">${examinationText}</div>`;
                  })
                  .join("")
              : ""
          }
          ${
            Array.isArray(examinationLocation) &&
            examinationLocation.length > 0 &&
            Boolean(formatLocationsText(examinationLocation))
              ? `<div class="content-item"><span class="location-label">Location: ${formatLocationsText(
                  examinationLocation
                )}</span></div>`
              : ""
          }
          ${
            examinationRemark
              ? `<div class="remark">${examinationRemark}</div>`
              : ""
          }
        </div>
      </div>
    `
          : ""
      }

      ${
        (report.impressions && report.impressions.length > 0) ||
        impressionRemark ||
        (Array.isArray(impressionLocation) && impressionLocation.length > 0)
          ? `
      <div class="section">
        <div class="section-title">ASSESMENT</div>
        <div class="section-content">
          ${
            report.impressions && report.impressions.length > 0
              ? report.impressions
                  .map((item) => {
                    let html = `<div class="content-item"><span>${item.description}</span>`;

                    if (item.scroll_downs && item.scroll_downs.length > 0) {
                      html += ` <span>${item.scroll_downs.join(", ")}</span>`;
                    }

                    html += `</div>`;
                    return html;
                  })
                  .join("")
              : ""
          }
          ${
            Array.isArray(impressionLocation) &&
            impressionLocation.length > 0 &&
            Boolean(formatLocationsText(impressionLocation))
              ? `<div class="content-item"><span class="location-label">Location: ${formatLocationsText(
                  impressionLocation
                )}</span></div>`
              : ""
          }
          ${
            impressionRemark
              ? `<div class="remark">${impressionRemark}</div>`
              : ""
          }
        </div>
      </div>
    `
          : ""
      }

      ${
        (report.treatment_plans && report.treatment_plans.length > 0) ||
        treatmentRemark
          ? `
      <div class="section">
        <div class="section-title">PLAN</div>
        <div class="section-content">
          ${
            report.treatment_plans && report.treatment_plans.length > 0
              ? report.treatment_plans
                  .map((item) => {
                    let html = `<div class="examination-item"><span>${item.description}</span>`;

                    if (item.scroll_downs && item.scroll_downs.length > 0) {
                      html += `<div>${item.scroll_downs
                        .map(
                          (scroll) =>
                            `<div class="bullet-item">- ${scroll}</div>`
                        )
                        .join("")}</div>`;
                    }

                    html += `</div>`;
                    return html;
                  })
                  .join("")
              : ""
          }
          ${
            treatmentRemark
              ? `<div class="remark">${treatmentRemark}</div>`
              : ""
          }
        </div>
      </div>
    `
          : ""
      }
    </body>
    </html>
  `);

    printWindow?.focus();
    printWindow?.print();
  };

  const handleSaveReport = async () => {
    const allReports = await fetchData(reports);
    const user = getUser();

    const userReports = allReports.data.filter((report: any) => {
      return report.added_by === user._id;
    });

    const hasTrialExpired = (expirationTimeUTC: any) => {
      const currentTimeUTC = new Date().toISOString(); // Get current time in UTC
      return currentTimeUTC > expirationTimeUTC; // Compare current time with expiration time
    };

    if (
      user.type === "2" &&
      !isChecked &&
      hasTrialExpired(user.trial_expiry) &&
      !user.hasOwnProperty("expiryTime")
    ) {
      setSnackbar({
        open: true,
        message:
          "Your trial has expired. Please switch to the subscription mode.",
        severity: "error",
      });
      return;
    }

    if (user.type === "2" && (isExpired || localUser.package_name === null)) {
      setSnackbar({
        open: true,
        message: "Your trial has ended. Please renew your subscription.",
        severity: "error",
      });
      await updatetDataById(
        "Users",
        {
          package_name: null,
          phone_number: null,
          session_id: null,
          expiryTime: null,
        },
        localUser._id
      );
      const updatedUser = localUser;
      updatedUser.package_name = null;
      updatedUser.phone_number = null;
      updatedUser.session_id = null;
      updatedUser.expiryTime = null;
      updatedUser.subscription = "inactive";
      updatedUser.subscriptionOwner = false;
      updatedUser.subscriptionOwnerId = null;
      updatedUser.randomCode = null;
      localStorage.setItem("user", JSON.stringify(updatedUser));
      return;
    }

    if (
      subscription
        ? user.type === "2" && userReports.length >= 10
        : user.type === "2" && userReports.length >= 1
    ) {
      setSnackbar({
        open: true,
        message: subscription
          ? "Your Note Limit has succeeded last note is replaced by new note"
          : "Your trial limit has succeeded last note is replaced by new note",
        severity: "error",
      });
      const lastReport = userReports[userReports.length - 1];
      if (report && report.complaints && report.complaints[0]) {
        let saveReport: any = { ...report };
        saveReport.duration = duration;
        saveReport.durationType = durationType;
        saveReport.complaintRemark = complaintRemark;
        saveReport.complaintLocation = complaintLocation;
        saveReport.otherSymptomDuration = otherSymptomDuration;
        saveReport.otherSymptomLocation = otherSymptomLocation;
        saveReport.otherSymptomDurationType = otherSymptomDurationType;
        saveReport.otherSymptomRemark = otherSymptomRemark;
        saveReport.historyDuration = historyDuration;
        saveReport.historyDurationType = historyDurationType;
        saveReport.historyRemark = historyRemark;
        // saveReport.subComplaintRemark = subComplaintRemark
        saveReport.impressionRemark = impressionRemark;
        saveReport.examinationRemark = examinationRemark;
        saveReport.examinationLocation = examinationLocation;
        saveReport.impressionLocation = impressionLocation;
        saveReport.assessmentLocation = impressionLocation;
        saveReport.treatmentRemark = treatmentRemark;

        const res = await updatetDataById(reports, saveReport, lastReport._id);
        setTimeout(() => {
          if (res.success) {
            navigate("/admin/notes");
          }
        }, 2000);
      } else {
        alert(
          "Note has no data or main complaint selected. Please create new note."
        );
      }
    } else {
      if (report && report.complaints && report.complaints[0]) {
        let saveReport: any = { ...report };
        saveReport.duration = duration;
        saveReport.durationType = durationType;
        saveReport.otherSymptomDuration = otherSymptomDuration;
        saveReport.otherSymptomDurationType = otherSymptomDurationType;
        saveReport.complaintLocation = complaintLocation;
        saveReport.otherSymptomLocation = otherSymptomLocation;
        saveReport.otherSymptomRemark = otherSymptomRemark;
        saveReport.historyDuration = historyDuration;
        saveReport.historyDurationType = historyDurationType;
        saveReport.historyRemark = historyRemark;
        saveReport.complaintRemark = complaintRemark;
        // saveReport.subComplaintRemark = subComplaintRemark
        saveReport.impressionRemark = impressionRemark;
        saveReport.examinationRemark = examinationRemark;
        saveReport.examinationLocation = examinationLocation;
        saveReport.impressionLocation = impressionLocation;
        saveReport.assessmentLocation = impressionLocation;
        saveReport.treatmentRemark = treatmentRemark;

        try {
          const res = await insertData(reports, saveReport);
          if (res.success) {
            navigate("/admin/notes");
          } else {
            // const isTokenExpired = () => {
            //     const expirationTime = localStorage.getItem('expirationTime');
            //     if (!expirationTime) return true;
            //     return new Date().getTime() > Number(expirationTime);
            //   };
            //   console.log("isTokenExpired++++++",isTokenExpired())

            //   if (isTokenExpired()) {
            //     localStorage.removeItem('expirationTime');
            //  navigate('/auth/sign-in');
            //   }
            alert(res.message);
            localStorage.removeItem("user");
            navigate("/auth/sign-in");
          }
        } catch (error: any) {
          const alreadyLoggedIn = error.message.endsWith("401");
          if (alreadyLoggedIn) {
            setSnackbar({
              open: true,
              message: "logged in from some other device",
              severity: "error",
            });
            setTimeout(() => {
              navigate("/auth/sign-in");
            }, 3000);
          }
        }
      } else {
        alert(
          "Note has no data or main complaint selected. Please create new note."
        );
      }
    }
  };

  useEffect(() => {
    const user = getUser();
    setLocalUser(user);
    const screenHeight = window.innerHeight;
    const eightyPercentHeight = screenHeight * 0.95;
    setScreenHeight(eightyPercentHeight);
    getData();
    user.package_name ? setSubscription(true) : setSubscription(false);
  }, []);

  useEffect(() => {
    const fetchUser = async () => {
      const user = await getUser();
      if (user && user.expiryTime) {
        const expirationDate = new Date(user.expiryTime);
        const currentDate = new Date();
        if (currentDate > expirationDate) {
          setIsExpired(true);
        } else {
          setIsExpired(false);
        }
      }
    };

    fetchUser();
  }, [navigate]);

  const handleErase = () => {
    setIsErase(true);
    setReport({
      system: null,
      complaints: [],
      otherSymptoms: [],
      history: [],
      examinations: [],
      impressions: [],
      treatment_plans: [],
    });
  };

  //Clear the data when user clicks on Wizard From Slidebar
  useEffect(() => {
    if (location.pathname === "/admin/wizard") {
      setPage(1);
      resetSelectedOptions();
      handleErase();

      setComplaintRemark("");
      setImpressionRemark("");
      setExaminationRemark("");
      setTreatmentRemark("");
      setOtherSymptomRemark("");
      setOtherSymptomDuration(null);
      setOtherSymptomDurationType("");
      setHistoryRemark("");
      setHistoryDuration(null);
      setHistoryDurationType("");
      setDuration(null);
      setDurationType("");
      setData([]);

      setComplaintLocation([]);
      setOtherSymptomLocation([]);
      setExaminationLocation([]);
      setImpressionLocation([]);

      setIsCompleted(false);
    }
  }, [location.key, location.pathname]);

  ///////Note: Running this function is very risky, it will change sorting according to the index value of data objects in collection
  // const sortAllDataOnDB = async function () {
  //     setLoading(true)
  //     const systemData = [...systemList]
  //     const complaintData = [...complaintList]
  //     const osData = [...otherSymptomList]
  //     const historyData = [...historyList]
  //     const examinationData = [...examinationList]
  //     const impressionData = [...impressionList]
  //     const planData = [...treatmentList]

  //     const updatedSystemData = systemData.map((obj, ind) => {
  //         let object = { ...obj }
  //         object.priority = ind
  //         return object
  //     })

  //     const updatedComplaintData = complaintData.map((obj, ind) => {
  //         let object: any = { ...obj }
  //         object.priority = ind
  //         if (object.scroll_downs && Array.isArray(object.scroll_downs) && object.scroll_downs.length >= 1) {
  //             let scrolls = [...object.scroll_downs]

  //             const updatedScrolls = scrolls.map((str: string, ind: number) => {
  //                 let updatedScroll = {
  //                     description: str,
  //                     priority: ind
  //                 }
  //                 return updatedScroll
  //             })

  //             object.scroll_downs = updatedScrolls
  //         }

  //         return object
  //     })

  //     const updatedOsData = osData.map((obj, ind) => {
  //         let object: any = { ...obj }
  //         object.priority = ind

  //         if (object.scroll_downs && Array.isArray(object.scroll_downs) && object.scroll_downs.length >= 1) {
  //             let scrolls = [...object.scroll_downs]
  //             const updatedScrolls = scrolls.map((str: string, ind: number) => {
  //                 let updatedScroll = {
  //                     description: str,
  //                     priority: ind
  //                 }
  //                 return updatedScroll
  //             })

  //             object.scroll_downs = updatedScrolls
  //         }

  //         return object
  //     })

  //     const updatedHistoryData = historyData.map((obj, ind) => {
  //         let object: any = { ...obj }
  //         object.priority = ind

  //         if (object.scroll_downs && Array.isArray(object.scroll_downs) && object.scroll_downs.length >= 1) {
  //             let scrolls = [...object.scroll_downs]
  //             const updatedScrolls = scrolls.map((str: string, ind: number) => {
  //                 let updatedScroll = {
  //                     description: str,
  //                     priority: ind
  //                 }
  //                 return updatedScroll
  //             })

  //             object.scroll_downs = updatedScrolls
  //         }

  //         return object
  //     })

  //     const updatedExaminationData = examinationData.map((obj, ind) => {
  //         let object: any = { ...obj }
  //         object.priority = ind

  //         if (object.scroll_downs && Array.isArray(object.scroll_downs) && object.scroll_downs.length >= 1) {
  //             let scrolls = [...object.scroll_downs]
  //             const updatedScrolls = scrolls.map((str: string, ind: number) => {
  //                 let updatedScroll = {
  //                     description: str,
  //                     priority: ind
  //                 }
  //                 return updatedScroll
  //             })

  //             object.scroll_downs = updatedScrolls
  //         }

  //         return object
  //     })

  //     const updatedImpressionData = impressionData.map((obj, ind) => {
  //         let object: any = { ...obj }
  //         object.priority = ind

  //         if (object.scroll_downs && Array.isArray(object.scroll_downs) && object.scroll_downs.length >= 1) {
  //             let scrolls = [...object.scroll_downs]
  //             const updatedScrolls = scrolls.map((str: string, ind: number) => {
  //                 let updatedScroll = {
  //                     description: str,
  //                     priority: ind
  //                 }
  //                 return updatedScroll
  //             })

  //             object.scroll_downs = updatedScrolls
  //         }

  //         return object
  //     })

  //     const updatedPlanData = planData.map((obj, ind) => {
  //         let object: any = { ...obj }
  //         object.priority = ind

  //         if (object.scroll_downs && Array.isArray(object.scroll_downs) && object.scroll_downs.length >= 1) {
  //             let scrolls = [...object.scroll_downs]
  //             const updatedScrolls = scrolls.map((str: string, ind: number) => {
  //                 let updatedScroll = {
  //                     description: str,
  //                     priority: ind
  //                 }
  //                 return updatedScroll
  //             })

  //             object.scroll_downs = updatedScrolls
  //         }

  //         return object
  //     })

  //     if (updatedSystemData && updatedSystemData.length > 0)
  //         await updatetManyDataById("Systems", updatedSystemData)
  //     if (updatedComplaintData && updatedComplaintData.length > 0)
  //         await updatetManyDataById("Complaints", updatedComplaintData)
  //     if (updatedOsData && updatedOsData.length > 0)
  //         await updatetManyDataById("OtherSymptoms", updatedOsData)
  //     if (updatedHistoryData && updatedHistoryData.length > 0)
  //         await updatetManyDataById("History", updatedHistoryData)
  //     if (updatedExaminationData && updatedExaminationData.length > 0)
  //         await updatetManyDataById("Examinations", updatedExaminationData)
  //     if (updatedImpressionData && updatedImpressionData.length > 0)
  //         await updatetManyDataById("Impressions", updatedImpressionData)
  //     if (updatedPlanData && updatedPlanData.length > 0)
  //         await updatetManyDataById("TreatmentPlans", updatedPlanData)
  //     setLoading(false)
  // }

  return (
    <>
      {!loading ? (
        <div
          className="relative flex justify-between"
          style={{ height: screenHeight }}
        >
          {
            !isCompleted ? (
              <Card extra={"w-full h-full px-4 mt-5 py-5 sm:w-[75%]"}>
                <h1 className="text-textPrimary w-[100%] text-left text-[26px] font-semibold sm:w-[70%]">
                  Medical Note Wizard
                </h1>
                <WizardManagement
                  updateReportList={updateReportList}
                  setIsCompleted={setIsCompleted}
                  data={data}
                  setData={setData}
                  page={page}
                  setPage={setPage}
                  systemList={systemList}
                  complaintList={complaintList}
                  complaintRemark={complaintRemark}
                  setComplaintRemark={setComplaintRemark}
                  durationList={durationList}
                  duration={duration}
                  setDuration={setDuration}
                  durationType={durationType}
                  setDurationType={setDurationType}
                  otherSymptomList={otherSymptomList}
                  otherSymptomRemark={otherSymptomRemark}
                  setOtherSymptomRemark={setOtherSymptomRemark}
                  otherSymptomDuration={otherSymptomDuration}
                  setOtherSymptomDuration={setOtherSymptomDuration}
                  otherSymptomDurationType={otherSymptomDurationType}
                  setOtherSymptomDurationType={setOtherSymptomDurationType}
                  historyList={historyList}
                  historyRemark={historyRemark}
                  setHistoryRemark={setHistoryRemark}
                  historyDuration={historyDuration}
                  setHistoryDuration={setHistoryDuration}
                  historyDurationType={historyDurationType}
                  setHistoryDurationType={setHistoryDurationType}
                  examinationList={examinationList}
                  examinationRemark={examinationRemark}
                  setExaminationRemark={setExaminationRemark}
                  impressionList={impressionList}
                  impressionRemark={impressionRemark}
                  setImpressionRemark={setImpressionRemark}
                  locationList={filteredLocations}
                  treatmentList={treatmentList}
                  treatmentRemark={treatmentRemark}
                  setTreatmentRemark={setTreatmentRemark}
                  resetSelectedOptions={resetSelectedOptions}
                  resetTrigger={resetTrigger}
                  setResetTrigger={setResetTrigger}
                  complaintLocation={complaintLocation}
                  setComplaintLocation={setComplaintLocation}
                  otherSymptomLocation={otherSymptomLocation}
                  setOtherSymptomLocation={setOtherSymptomLocation}
                  examinationLocation={examinationLocation}
                  setExaminationLocation={setExaminationLocation}
                  impressionLocation={impressionLocation}
                  setImpressionLocation={setImpressionLocation}
                  onVoiceReportGenerated={handleVoiceReportGenerated}
                />
              </Card>
            ) : (
              // <div className="relative flex justify-between">
              <Card
                extra={
                  "w-full h-full sm:overflow-auto px-8 mt-5 py-5 sm:w-[69%]"
                }
              >
                <Lottie
                  style={{
                    pointerEvents: "none",
                    margin: 0,
                    alignSelf: "center",
                  }}
                  width={200}
                  options={{
                    loop: true,
                    autoplay: true,
                    animationData: completeAnimation,
                  }}
                />
                <h1 className="text-textPrimary mt-3 w-[100%] text-center text-[26px] font-semibold sm:w-[100%]">
                  Note Completed
                </h1>

                <div className="relative mt-5 flex justify-center py-5">
                  <button
                    key={"print090"}
                    onClick={printReport}
                    className={`linear mr-3 flex w-40 items-center justify-center rounded-lg bg-brand-500 p-3 text-sm font-bold text-white transition duration-200 hover:cursor-pointer hover:bg-brand-500/80 active:bg-brand-500/70`}
                  >
                    Print Note
                  </button>

                  <button
                    key={"save090"}
                    onClick={handleSaveReport}
                    className={`linear mr-3 flex w-40 items-center justify-center rounded-lg bg-copyBtnSurface p-3 text-sm font-bold text-white transition duration-200 hover:cursor-pointer hover:bg-copyBtnSurface/80 active:bg-copyBtnSurface/70`}
                  >
                    Save Note
                  </button>

                  <button
                    key={"new090"}
                    onClick={() => {
                      window.location.reload();
                    }}
                    className={`w-50 linear mr-3 flex items-center justify-center rounded-lg bg-surfaceSecondary p-3 text-sm font-bold text-brand-500 transition duration-200 hover:cursor-pointer hover:bg-surfaceSecondary/80 active:bg-surfaceSecondary/70`}
                  >
                    Create New Note &nbsp;&nbsp; <MdAddCircle />
                  </button>
                </div>
              </Card>
            )
            // </div>
          }
          <Card
            extra={"w-full h-full sm:overflow-auto px-8 mt-5 py-5 sm:w-[25%]"}
          >
            <WizardReport
              data={data}
              setData={setData}
              page={page}
              setPage={setPage}
              userReport={report}
              setReport={handleErase}
              complaintRemark={complaintRemark}
              setComplaintRemark={setComplaintRemark}
              duration={duration}
              setDuration={setDuration}
              durationType={durationType}
              setDurationType={setDurationType}
              otherSymptomRemark={otherSymptomRemark}
              setOtherSymptomRemark={setOtherSymptomRemark}
              otherSymptomDuration={otherSymptomDuration}
              setOtherSymptomDuration={setOtherSymptomDuration}
              otherSymptomDurationType={otherSymptomDurationType}
              setOtherSymptomDurationType={setOtherSymptomDurationType}
              historyRemark={historyRemark}
              setHistoryRemark={setHistoryRemark}
              historyDuration={historyDuration}
              setHistoryDuration={setHistoryDuration}
              historyDurationType={historyDurationType}
              setHistoryDurationType={setHistoryDurationType}
              examinationRemark={examinationRemark}
              setExaminationRemark={setExaminationRemark}
              impressionRemark={impressionRemark}
              setImpressionRemark={setImpressionRemark}
              treatmentRemark={treatmentRemark}
              setTreatmentRemark={setTreatmentRemark}
              resetSelectedOptions={resetSelectedOptions}
              complaintLocation={complaintLocation}
              setComplaintLocation={setComplaintLocation}
              otherSymptomLocation={otherSymptomLocation}
              setOtherSymptomLocation={setOtherSymptomLocation}
              examinationLocation={examinationLocation}
              setExaminationLocation={setExaminationLocation}
              impressionLocation={impressionLocation}
              setImpressionLocation={setImpressionLocation}
            />
          </Card>
        </div>
      ) : (
        <div className="flex min-h-screen items-center justify-center">
          <div className="h-10 w-10 animate-spin rounded-full border-4 border-dashed border-brand-500"></div>
          <div className="text-textPrimary ml-2 text-[18px] font-semibold">
            Just a moment, getting things ready...
          </div>
        </div>
      )}

      {/* <button onClick={async () => { await sortAllDataOnDB() }} className="block absolute bottom-10 left-10 z-100 bg-red-600 hover:bg-red-700 rounded-md text-white px-5 py-2">Sort All Data</button> */}

      <AppSnackbar
        isOpen={snackbar.open}
        title={snackbar.message}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        severity={snackbar.severity}
      />
    </>
  );
};

export default Wizard;
